import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';

const CircleContainer = styled.div`
    align-self: center;
`;

const rotateKeyframes = keyframes`
  to {
    transform: rotate(1turn);
  }
`;

const rotateAnimation = css`
    ${rotateKeyframes} 2s linear infinite
`;

const StyledCircularProgressbarWithChildren = styled((props) => (
    <CircularProgressbarWithChildren background {...props} />
))`
    animation: ${(props) => (props.$preLoadMode ? rotateAnimation : 'none')};

    .CircularProgressbar-background {
        fill: white;
        opacity: 0.8;
    }
    .CircularProgressbar-path {
        stroke-linecap: butt;
        stroke: ${({ theme, $preLoadMode }) => {
            if ($preLoadMode) {
                return `rgba(0, 0, 0, 0.2)`;
            }
            return theme.color.navigationColor;
        }};
    }
    .CircularProgressbar-text {
        // zero opacity in pre-load so that if fades in when changes
        opacity: ${(props) => (props.$preLoadMode ? 0 : 1)};
        transition: 0.25s opacity;
        fill: ${({ theme }) => theme.color.highlightColor};
    }

    .CircularProgressbar-trail {
        stroke-linecap: butt;
    }

    ${CircleContainer}:hover & .CircularProgressbar-background {
        fill: ${({ theme, $preLoadMode }) =>
            $preLoadMode ? null : theme.color.navigationColorVariants.w15};
    }
`;

function CircularLoader(props) {
    const { loadingProgress, loadingValue } = props;

    // zero means we should display in 'preload' mode
    if (loadingProgress === 0) {
        return (
            <CircleContainer>
                <StyledCircularProgressbarWithChildren
                    $preLoadMode={true}
                    value={10}
                    text="0%"
                ></StyledCircularProgressbarWithChildren>
            </CircleContainer>
        );
    }

    if (loadingProgress < 1) {
        const valueCeil = Math.ceil(loadingProgress);

        return (
            <CircleContainer>
                {loadingProgress < 1 && (
                    <StyledCircularProgressbarWithChildren
                        $preLoadMode={false}
                        value={valueCeil}
                        text={`${valueCeil}%`}
                    ></StyledCircularProgressbarWithChildren>
                )}
            </CircleContainer>
        );
    }

    return (
        <CircleContainer>
            {loadingValue < 100 && (
                <StyledCircularProgressbarWithChildren
                    $preLoadMode={false}
                    value={loadingValue}
                    text={`${loadingValue}%`}
                ></StyledCircularProgressbarWithChildren>
            )}

            {loadingValue === 100 && (
                <StyledCircularProgressbarWithChildren value={loadingValue}>
                    {props.children}
                </StyledCircularProgressbarWithChildren>
            )}
        </CircleContainer>
    );
}

export default CircularLoader;
